<template>
    <Link v-if="href" :href="href" class="bg-green rounded shadow-md text-white font-bold text-xs uppercase px-4 py-2 hover:bg-green-dark focus:bg-green-dark">
        <slot></slot>
    </Link>

    <button v-else :type="type" class="inline-flex items-center px-4 py-2 bg-green rounded shadow-md text-white font-bold text-xs uppercase tracking-widest hover:bg-green-dark active:bg-green-dark focus:outline-none focus:ring focus:ring-green focus:ring-opacity-50 disabled:opacity-25 disabled:cursor-not-allowed transition border-none">
        <slot></slot>
    </button>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
    props: {
        type: {
            type: String,
            default: 'submit',
        },
        href: String,
    },

    components: {
        Link,
    }
}
</script>
